import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UnlockCandidate } from "./UnlockCandidateAPI";

const initialState = {
    data: null,
    loading: false,
    error: null,
    successMessage: null
};

export const UnlockCandidateAsync = createAsyncThunk(
    "UnlockCandidate/add",
    async ({ uuid }, { rejectWithValue }) => {
        try {
            const data = await UnlockCandidate(uuid);
            // console.log("Unlock API response data:", data);
            return data;
        } catch (error) {
            console.error("Error in UnlockCandidateAsync:", error);
            return rejectWithValue(error.message || "Failed to unlock candidate");
        }
    }
);

const UnlockCandidateSlice = createSlice({
    name: "UnlockCandidate",
    initialState,
    reducers: {
        resetUnlockState: (state) => {
            state.data = null;
            state.error = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(UnlockCandidateAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(UnlockCandidateAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = "Candidate unlocked successfully";
                state.error = null;
            })
            .addCase(UnlockCandidateAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to unlock candidate";
                state.successMessage = null;
            });
    },
});

export const { resetUnlockState } = UnlockCandidateSlice.actions;
export const selectJob = (state) => state.UnlockCandidate.data;
export const selectUnlockLoading = (state) => state.UnlockCandidate.loading;
export const selectUnlockError = (state) => state.UnlockCandidate.error;
export const selectUnlockSuccess = (state) => state.UnlockCandidate.successMessage;

export default UnlockCandidateSlice.reducer;